export const getSx = () => {
  return {
    adDetailSec: {
      position: "relative",
    },
    content: {
      width: {
        xs: "calc(100% - 47px)",
        sm: "calc(100% - 111px)",
        md: "calc(100% - 82px)",
      },
      background: "#ffffff",
      marginBottom: "45px",
      padding: { xs: "25px", sm: "40px", md: "40px" },
      border: "1px solid rgba(0, 148, 217, 0.20)",
      borderRadius: "20px",
      maxHeight: "calc(100vh - 240px)",
      overflowY: "auto",
    },
    contentBox: {
      width: "100%",
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      alignItems: "flex-start",
      gap: "2rem",
    },
    imageWrapper: {
      width: { xs: "179px", md: "212px" },
      height: "225px",
      borderRadius: "32px",
      background: "#ffffff",
      border: "2px solid rgba(0, 148, 217, 0.20)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      float: "left",
    },
    rightBoxContainer: {
      marginTop: "1rem",
      display: "flex",
      flexDirection: "column",
      gap: "6px",
      position: "relative",
    },
    rightBox: {
      display: "flex",
      alignItems: "center",
      zIndex: 1,
      justifyContent: { xs: "center", sm: "" },
      position: { xs: "", sm: "absolute" },
      top: "-10px",
      right: 0,
    },
    editIconContainer: {
      marginRight: "15px",
      position: "relative",
      top: "-3px",
      cursor: "pointer",
      backgroundColor: "transparent",
      padding: 0,
      height: "auto",
      border: 0,
    },
    deleteIconContainer: {
      marginLeft: "15px",
      cursor: "pointer",
      backgroundColor: "transparent",
      padding: 0,
      height: "auto",
      border: 0,
    },
    icon: {
      width: "auto",
      height: "auto",
    },
    name: {
      fontSize: "18px",
      fontWeight: 600,
      opacity: "0.8",
      marginBottom: "8px",
    },
    lightText: {
      opacity: "0.75",
    },
    recurrenceType: {
      color: "#687F89",
      fontSize: { xs: "13px", sm: "14px", lg: "18px" },
      fontWeight: 400,
      marginRight: "12px",
      marginBottom: "8px",
    },
    calendarIcon: {
      width: "24px",
      height: "24px",
      marginRight: "5px",
    },
    descriptionText: {
      color: "primary.dark",
      fontSize: "20px",
      fontWeight: 500,
      lineHeight: "26px",
    },
    description: {
      margin: "25px 0",
      fontSize: "16px",
      fontWeight: 400,
      color: "#687f89",
      lineHeight: "30px",
    },
    viewsBloc: {
      width: "130px",
      height: "40px",
      border: "1px solid rgba(0, 148, 217, 0.40)",
      borderRadius: "20px",
      padding: "10px",
      marginRight: "20px",
      display: "flex",
      alignItems: "center",
    },
    viewsBlocContent: {
      float: "left",
      width: "calc(100% - 45px)",
      paddingLeft: "12px",
    },
    viewsBlocIconsWrapper: {
      float: "left",
      width: "37px",
      height: "39px",
    },
    viewsBlocIcons: {
      width: "100%",
      height: "100%",
    },
    totalViews: {
      color: "primary.dark",
      fontWeight: 400,
      lineHeight: 1,
      fontSize: { xs: "14px", sm: "20px" },
    },
    totalViewsText: {
      color: "primary.dark",
      fontWeight: 300,
      opacity: "0.4",
      fontSize: { xs: "10px", sm: "14px" },
    },
    Icons: {
      width: "130px",
      height: "40px",
      border: "1px solid rgba(0, 148, 217, 0.40)",
      borderRadius: "20px",
      padding: "10px",
      display: "flex",
      alignItems: "center",
    },
    totalSaves: {
      color: "primary.dark",
      fontWeight: 400,
      lineHeight: 1,
      fontSize: { xs: "14px", sm: "20px" },
    },
    totalSavesText: {
      color: "primary.dark",
      fontWeight: 300,
      opacity: "0.4",
      fontSize: { xs: "10px", sm: "14px" },
    },
    clockIconWrapper: {
      color: "#687F89",
      fontSize: { xs: "13px", sm: "14px", lg: "18px" },
      fontWeight: 400,
      marginBottom: "8px",
    },
    clockIcon: {
      width: "24px",
      height: "24px",
      marginRight: "5px",
    },
    recurrenceTypeText: {
      marginRight: "12px",
      marginBottom: "8px",
      color: "#E8AA42",
      fontSize: { xs: "13px", sm: "14px", lg: "18px" },
      fontWeight: 400,
    },
  };
};
